import { render, staticRenderFns } from "./SortArrowIcon.vue?vue&type=template&id=c1cf7cf6&scoped=true&"
import script from "./SortArrowIcon.vue?vue&type=script&lang=js&"
export * from "./SortArrowIcon.vue?vue&type=script&lang=js&"
import style0 from "./SortArrowIcon.vue?vue&type=style&index=0&id=c1cf7cf6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1cf7cf6",
  null
  
)

export default component.exports